import { Box } from '@mui/material';

function DropIndicator({ position, offset = 2 }) {
    const posStyles = {
        top: {
            width: '100%',
            top: -offset,
            height: 4,
        },
        bottom: {
            width: '100%',
            bottom: -offset,
            height: 4,
        },
        left: {
            height: '100%',
            left: -offset,
            width: 4,
        },
        right: {
            height: '100%',
            right: -offset,
            width: 4,
        },
    };

    const styles = posStyles?.[position] || {};

    return (
        <Box
            sx={{
                position: 'absolute',
                pointerEvents: 'none',
                backgroundColor: theme => theme.palette.primary.main,
                borderRadius: 99,
                ...styles,
            }}
        />
    );
}

export default DropIndicator;
